export const AppPermissionsDataHooks = {
  CONTAINER: 'app-permissions',
};
